// @flow

import {
  createSequoiaResource,
  type SequoiaResource,
  type SequoiaResourceType,
} from '@gandi/resource/redux';

type DateRef = 'date_now' | 'date_exhaust' | 'keep';

type ModeAmount = {
  amount: number,
  date_ref?: DateRef,
  duration_unit?: void,
  duration?: void,
};

type ModeDuration = {
  amount?: void,
  date_ref?: void,
  duration_unit: string,
  duration: number,
};

type ModeDateRef = {
  amount?: void,
  date_ref: DateRef,
  duration_unit?: void,
  duration?: void,
};

type Mode = ModeAmount | ModeDateRef | ModeDuration;

type DiscountWithAmount = {
  description: string,
  price_after_taxes: number,
  price_before_taxes: number,
};

type DiscountWithDuration = {
  description: string,
  duration: string,
};

type Discount = DiscountWithAmount | DiscountWithDuration;

type Taxe = {
  type: 'service' | string,
  name: 'vat' | string,
  rate: number,
};

export type Quotation = {
  contracts?: Array<{
    href: string,
    id: string,
    name: string,
  }>,
  balance?: {
    currency: string,
    grid: string,
    price_after_taxes: number,
    price_before_taxes: number,
    taxes: Array<Taxe>,
  },
  consumption?: {
    added: {
      currency: string,
      duration_unit: string,
      duration: number,
      grid: string,
      price_after_taxes: number,
      price_before_taxes: number,
      taxes: Array<Taxe>,
    },
    after: {
      currency: string,
      date_exhaust: string,
      duration_unit: string,
      duration: number,
      grid: string,
      price_after_taxes: number,
      price_before_taxes: number,
      taxes: Array<Taxe>,
    },
    current: {
      currency: string,
      date_exhaust: string,
      duration_unit: string,
      duration: number,
      grid: string,
      price_after_taxes: number,
      price_before_taxes: number,
      taxes: Array<Taxe>,
    },
  },
  prices: Array<{
    currency: string,
    date_exhaust: string,
    date_now: string,
    discounts_suggest?: Array<string>,
    discounts?: Array<Discount>,
    duration_unit: string,
    duration: number,
    grid: string,
    mode: Mode,
    normal_price_after_taxes?: number,
    normal_price_before_taxes?: number,
    price_after_taxes: number,
    price_before_taxes: number,
    taxes: Array<Taxe>,
  }>,
};

export type QuotationPostPayload = Array<{
  consumption: {
    duration: number,
    duration_unit: string,
  },
  modes: Array<Mode>,
  server?: {
    cores: number,
    memory: number,
    ips: Array<{
      version: 4 | 6,
    }>,
    volumes: Array<{
      size: number,
    }>,
  },
}>;

type ServersResourceType = SequoiaResourceType<{
  postPayload: QuotationPostPayload,
}>;

export type ServersResource = SequoiaResource<ServersResourceType>;

export const quotationsResource: ServersResource = createSequoiaResource(
  'cloud',
  'quotations',
  {
    postPath: 'balance/quotations',
  },
);
